











































































































































helpers = require('../../helpers.coffee')

view_model = {
  props: ['contact']

  data: ->
    business_class: ''
    business_help_text: ''
    pristine: true
    apiErrorMessages: []
    current_user: Session.current_user
    user_is_monitoring_manager: Session.current_user.isMonitoringManager()
    contact_custom_fields: []
    custom_fields: []

  computed:
    change_business_name: ->
      slugify(@contact.business.name) == slugify(@contact.base_business_name)

  watch:
    'contact.contact_custom_fields':
      handler: (new_value, old_value) ->
        for custom_field in new_value
          if custom_field.kind == 'telephone'
            custom_field.value = helpers.masks.maskPhoneInput(custom_field.value)
      deep: true

    'contact.telephone':
      handler: (new_value, old_value) ->
        return unless old_value?

        if new_value?
          @contact.telephone = helpers.masks.maskPhoneInput(@contact.telephone)
        else
          @contact.telephone = ''

    'contact.cellphone':
      handler: (new_value, old_value) ->
        return unless old_value?
        
        if new_value?
          @contact.cellphone = helpers.masks.maskPhoneInput(@contact.cellphone)
        else
          @contact.cellphone = ''

  methods:
    custom_field_mask: (custom_field) ->
      switch custom_field.kind
        when 'date' then '##/##/####'
        else ''

    update_business_class: ->
      return @business_class = 'has-error' if @errors.has('business')
      return @business_class = 'has-warning' unless @change_business_name

      @business_class = ''

    update_business_help_text: ->
      return @business_help_text = @errors.first('business') if @errors.has('business')
      return @business_help_text = '' if @change_business_name

      @business_help_text = "O contato será transferido da empresa #{@contact.base_business_name} para #{@contact.business.name}"

    updated_base_business: (evt) ->
      @update_business_class()
      @update_business_help_text()

    submit: ->
      @$validator.validateAll().then (success) =>
        @save() if success

    save: ->
      Loader.on()
      @contact.contact_custom_fields_attributes = @contact.contact_custom_fields
      @contact.business_name = @contact.business.name
      @contacts_resource.update @saveSuccess, @saveError, @contact

    saveError: (response) ->
      Loader.off()
      @handleApiErrors(response)
      alertify.error "Ops, algo deu errado!"
      return unless response.body

      for key, field of response.body
        if key.search(/^contact_custom_fields.*/) > -1
          msg = "O campo #{field[0].custom_field_name} é inválido"
          @errors.add("custom_field_#{field[0].custom_field_id}", msg)

        @errors.add('telephone', 'O campo Telefone é inválido') if key == 'telephone'
        @errors.add('cellphone', 'O campo Celular é inválido') if key == 'cellphone'
    saveSuccess: (resources) ->
      Loader.off()
      EventsBus.$emit 'contact-updated', resources.contact
      alertify.success 'Contato atualizado com sucesso'
      @business_class = ''
      @business_help_text = ''
      IntercomCtrl.trackEvent("Base de contatos - Contato atualizado.")

    isValid: ->
      !@errors.any() and !@anyActionErrors()

    customFieldColumnClass: (index) ->
      if (index + 1) == @contact.contact_custom_fields.length && (@contact.contact_custom_fields.length % 2 == 1) 
        'col-md-12'
      else if @contact.contact_custom_fields[index].kind == 'textarea'
        'col-md-12'
      else
        'col-md-6'

  mounted: ->
    @errors.clear()
    @contacts_resource = new ContactsResource Session.current_company.id
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/form.vue